import React from "react";
import { Link } from "react-router-dom";

import styled from "styled-components";

const Container = styled.div`
    a {
        text-decoration: none;
    }

    .nav-card-square {
        background: #fff;
        color: #002666;
        font-size: 30px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 25px;
        width: 158%;

        @media (max-width: 768px) {
        width: 158px;
  }
    }

    .nav-card-active-square {
        background: #ffb615;
    }

    .nav-card-title {
        color: #fff;
        font-weight: bold;
        text-align: center;
        font-size: 20px
    }


    .nav-card-active-title2 {
        color: #002666;
        margin-left: 30px;
    }


`;

function CategoryCard({ title, icon, href, active = '0', onClick }) {

  let square_class = 'nav-card-square'
  let title_class = 'nav-card-title'

  if (active === '1') {
    square_class = 'nav-card-square nav-card-active-square'
    title_class = 'nav-card-title nav-card-active-title'
  }
  if (active === '2') {
    square_class = 'nav-card-square nav-card-active-square'
    title_class = 'nav-card-title nav-card-active-title2'
  }


  return (
    <Container onClick={onClick}>
      <Link to={href}>
        <div className={square_class}>
          <i className={icon} />
          <div className={title_class}>{title}</div>
        </div>
      </Link>
    </Container>
  )
}

export default CategoryCard;
